import IngredientsPanel from './IngredientsPanelContainer';
export default IngredientsPanel;
